// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src//assets/icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.navigation-link:hover::after {
  width: 100%;
  height: 100%;
  opacity: 1;
  border-radius: 5px;
  left: 0;
  top: 0;
}
.navigation-link::after {
  content: "";
  width: 0%;
  height: 0%;
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 50%;
  background-color: #2121f10b;
  opacity: 0.5;
  transition: all 300ms ease-in-out;
}
.navigation-link {
  position: relative;
}

.action-container {
  transition: var(--transition);
  width: 43.3%;
  height: 100%;
  background-color: white;
  right: -33.34%;
  position: fixed;
  opacity: 0.5;
  z-index: 3;
  top: 0;
}
.action-visible .action-container {
  right: 0 !important;
  opacity: 1;
}
table {
  border-radius: 15px;
  border-style: hidden;
  box-shadow: 0 0 0 1px #E8E8E8;
  overflow: clip;
}

select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none; /* Remove default focus outline */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace "arrow.png" with the path to your arrow image */
  background-repeat: no-repeat;
  background-position: 95% 50%; /* Adjust the right padding of the arrow */
  background-size: 19px;
}
select::after {
  content: "\\25BC"; /* Unicode arrow down character */
  position: absolute;
  top: 50%;
  right: 15px; /* Adjust the right padding of the arrow */
  transform: translateY(-50%);
  font-size: 16px;
  pointer-events: none; /* Ensure the arrow doesn't interfere with clicking the select */
}

/* Hide default arrow in certain browsers */
select::-ms-expand {
  display: none;
}

.jw-anim {
  --border-width: 3px;
  position: relative;
  border-radius: var(--border-width);
  cursor: pointer;
  z-index: 0;
}

  .jw-anim::after  {
    --border-width: 3px;
    position: absolute;
    content: "";
    top: calc(-1 * var(--border-width));
    left: calc(-1 * var(--border-width));
    z-index: 0;
    width: calc(100% + var(--border-width) * 2);
    height: calc(100% + var(--border-width) * 2);
    background: linear-gradient(
      60deg,
      hsl(224, 85%, 66%),
      hsl(269, 85%, 66%),
      hsl(314, 85%, 66%),
      hsl(359, 85%, 66%),
      hsl(44, 85%, 66%),
      hsl(89, 85%, 66%),
      hsl(134, 85%, 66%),
      hsl(179, 85%, 66%)
    );
    background-size: 300% 300%;
    background-position: 0 50%;
    border-radius: calc(2 * var(--border-width));
    animation: moveGradient 2s alternate infinite;
  }


@keyframes moveGradient {
  50% {
    background-position: 100% 50%;
  }
}
.jw-anim div {
  border-radius: 3px;
}
.jw-anim div span {
  transition: var(--transition);
}
.jw-anim:hover div span:first-child {
  margin-right: 12px;
}
.round-checkbox label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  height: 25px;
  width: 25px;
  position: absolute;
  left: 0;
  top: 0;
}
.round-checkbox label::after {
  border: 2px solid #1B0A4B;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}
.round-checkbox input[type="checkbox"] {
  visibility: hidden;
}
.round-checkbox input[type="checkbox"]:checked + label {
  background-color: #1EA68A;
  border: none;
}
.round-checkbox input[type="checkbox"]:checked + label::after {
  opacity: 1;
}


.tab-selected {
  background: linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04));
  border: 0.5px solid #0000000A;
  box-shadow: 0px 3px 1px 0px #0000000A;
  box-shadow: 0px 3px 8px 0px #0000001F;
  border-radius: 9px;
}

input, textarea, select {
  outline: none;
}

input {
  font-size: 14px;
}


svg {
  -webkit-user-select: none;
          user-select: none;
}

img[aria-label="icon"] {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.--box-shadow {
  box-shadow: 0px 4px 50px 5px #0000000D;
  background-color: white;
  padding: 8px;
  border-radius: 8px
}


.loader-line {
  width: 100%;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  border-radius: 20px;
}

.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: coral;
  animation: lineAnim 1s linear infinite;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
      left: -40%;
  }
  50% {
      left: 20%;
      width: 80%;
  }
  100% {
      left: 100%;
      width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;AACA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;EACV,MAAM;AACR;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa,EAAE,iCAAiC;EAChD,yDAA4D,EAAE,0DAA0D;EACxH,4BAA4B;EAC5B,4BAA4B,EAAE,0CAA0C;EACxE,qBAAqB;AACvB;AACA;EACE,gBAAgB,EAAE,iCAAiC;EACnD,kBAAkB;EAClB,QAAQ;EACR,WAAW,EAAE,0CAA0C;EACvD,2BAA2B;EAC3B,eAAe;EACf,oBAAoB,EAAE,gEAAgE;AACxF;;AAEA,2CAA2C;AAC3C;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,UAAU;AACZ;;EAEE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,mCAAmC;IACnC,oCAAoC;IACpC,UAAU;IACV,2CAA2C;IAC3C,4CAA4C;IAC5C;;;;;;;;;;KAUC;IACD,0BAA0B;IAC1B,0BAA0B;IAC1B,4CAA4C;IAC5C,6CAA6C;EAC/C;;;AAGF;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,oHAAoH;EACpH,6BAA6B;EAC7B,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ;AACF;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EAGtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,uBAAuB;EAGvB,sCAAsC;EAGtC,mBAAmB;AACrB;;AAEA;EACE;MACI,UAAU;EACd;EACA;MACI,SAAS;MACT,UAAU;EACd;EACA;MACI,UAAU;MACV,WAAW;EACf;AACF","sourcesContent":["\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.navigation-link:hover::after {\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n  border-radius: 5px;\n  left: 0;\n  top: 0;\n}\n.navigation-link::after {\n  content: \"\";\n  width: 0%;\n  height: 0%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 50%;\n  background-color: #2121f10b;\n  opacity: 0.5;\n  transition: all 300ms ease-in-out;\n}\n.navigation-link {\n  position: relative;\n}\n\n.action-container {\n  transition: var(--transition);\n  width: 43.3%;\n  height: 100%;\n  background-color: white;\n  right: -33.34%;\n  position: fixed;\n  opacity: 0.5;\n  z-index: 3;\n  top: 0;\n}\n.action-visible .action-container {\n  right: 0 !important;\n  opacity: 1;\n}\ntable {\n  border-radius: 15px;\n  border-style: hidden;\n  box-shadow: 0 0 0 1px #E8E8E8;\n  overflow: clip;\n}\n\nselect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  outline: none; /* Remove default focus outline */\n  background-image: url(\"/src//assets/icons/chevron-down.svg\"); /* Replace \"arrow.png\" with the path to your arrow image */\n  background-repeat: no-repeat;\n  background-position: 95% 50%; /* Adjust the right padding of the arrow */\n  background-size: 19px;\n}\nselect::after {\n  content: \"\\25BC\"; /* Unicode arrow down character */\n  position: absolute;\n  top: 50%;\n  right: 15px; /* Adjust the right padding of the arrow */\n  transform: translateY(-50%);\n  font-size: 16px;\n  pointer-events: none; /* Ensure the arrow doesn't interfere with clicking the select */\n}\n\n/* Hide default arrow in certain browsers */\nselect::-ms-expand {\n  display: none;\n}\n\n.jw-anim {\n  --border-width: 3px;\n  position: relative;\n  border-radius: var(--border-width);\n  cursor: pointer;\n  z-index: 0;\n}\n\n  .jw-anim::after  {\n    --border-width: 3px;\n    position: absolute;\n    content: \"\";\n    top: calc(-1 * var(--border-width));\n    left: calc(-1 * var(--border-width));\n    z-index: 0;\n    width: calc(100% + var(--border-width) * 2);\n    height: calc(100% + var(--border-width) * 2);\n    background: linear-gradient(\n      60deg,\n      hsl(224, 85%, 66%),\n      hsl(269, 85%, 66%),\n      hsl(314, 85%, 66%),\n      hsl(359, 85%, 66%),\n      hsl(44, 85%, 66%),\n      hsl(89, 85%, 66%),\n      hsl(134, 85%, 66%),\n      hsl(179, 85%, 66%)\n    );\n    background-size: 300% 300%;\n    background-position: 0 50%;\n    border-radius: calc(2 * var(--border-width));\n    animation: moveGradient 2s alternate infinite;\n  }\n\n\n@keyframes moveGradient {\n  50% {\n    background-position: 100% 50%;\n  }\n}\n.jw-anim div {\n  border-radius: 3px;\n}\n.jw-anim div span {\n  transition: var(--transition);\n}\n.jw-anim:hover div span:first-child {\n  margin-right: 12px;\n}\n.round-checkbox label {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  outline: none;\n  cursor: pointer;\n  height: 25px;\n  width: 25px;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.round-checkbox label::after {\n  border: 2px solid #1B0A4B;\n  border-top: none;\n  border-right: none;\n  content: \"\";\n  height: 6px;\n  left: 7px;\n  opacity: 0;\n  position: absolute;\n  top: 8px;\n  transform: rotate(-45deg);\n  width: 12px;\n}\n.round-checkbox input[type=\"checkbox\"] {\n  visibility: hidden;\n}\n.round-checkbox input[type=\"checkbox\"]:checked + label {\n  background-color: #1EA68A;\n  border: none;\n}\n.round-checkbox input[type=\"checkbox\"]:checked + label::after {\n  opacity: 1;\n}\n\n\n.tab-selected {\n  background: linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04));\n  border: 0.5px solid #0000000A;\n  box-shadow: 0px 3px 1px 0px #0000000A;\n  box-shadow: 0px 3px 8px 0px #0000001F;\n  border-radius: 9px;\n}\n\ninput, textarea, select {\n  outline: none;\n}\n\ninput {\n  font-size: 14px;\n}\n\n\nsvg {\n  user-select: none;\n}\n\nimg[aria-label=\"icon\"] {\n  pointer-events: none;\n  user-select: none;\n}\n\n.--box-shadow {\n  box-shadow: 0px 4px 50px 5px #0000000D;\n  background-color: white;\n  padding: 8px;\n  border-radius: 8px\n}\n\n\n.loader-line {\n  width: 100%;\n  height: 3px;\n  position: relative;\n  overflow: hidden;\n  background-color: #ddd;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n}\n\n.loader-line:before {\n  content: \"\";\n  position: absolute;\n  left: -50%;\n  height: 3px;\n  width: 40%;\n  background-color: coral;\n  -webkit-animation: lineAnim 1s linear infinite;\n  -moz-animation: lineAnim 1s linear infinite;\n  animation: lineAnim 1s linear infinite;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n}\n\n@keyframes lineAnim {\n  0% {\n      left: -40%;\n  }\n  50% {\n      left: 20%;\n      width: 80%;\n  }\n  100% {\n      left: 100%;\n      width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
